



























































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Session } from '@/types/core';
import { CoreClient, curCoreClient } from '@/services/CoreClient';

import tippy from 'tippy.js';

@Component
export default class NnnHeader extends Vue {
  
  private coreClient:CoreClient = curCoreClient;

  mounted() {
    tippy('[data-tippy-content]', {
      arrow: true,
      placement: 'bottom',
      theme: 'light-border',
      distance: 3,
    });
  }

  onLogout() {
    this.coreClient.doLogout();

    return this.$router.push({name:'login'});
  }
}
